import { Page } from '../services/DynamicPageService';

export const localPageData: Record<string, Page> = {
  'home': {
    id: 'home',
    name: 'Home',
    slug: 'home',
    isActive: true,
    settings: {
      seoTitle: 'Aarit Special School & Therapy Centre - Home',
      seoDescription: 'Empowering Every Child\'s Potential with specialized education and therapeutic support',
      metaKeywords: 'special education, therapy, children, special needs, Aarit School',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'home-hero',
        type: 'rich-landing',
        title: 'Home Hero Section',
        content: {
          contentType: 'mixed',
          videoUrl: 'https://example.com/sample-video.mp4',
          videoPoster: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=600&fit=crop',
          photoUrls: [
            'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=600&fit=crop',
            'https://images.unsplash.com/photo-1523050854058-8df90110c9e1?w=800&h=600&fit=crop',
            'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=600&fit=crop',
            'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&h=600&fit=crop'
          ],
          photoCaptions: [
            'Special Education Excellence',
            'Therapeutic Support',
            'Individualized Learning',
            'Nurturing Environment'
          ],
          photoColumns: 2,
          showPhotoCaptions: true,
          showFloatingElements: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'home',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'home-about',
        type: 'about-block',
        title: 'Home About Section',
        content: {},
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'home',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'home-gallery',
        type: 'gallery-block',
        title: 'Home Gallery Section',
        content: {},
        isActive: true,
        order: 3,
        settings: {},
        pageId: 'home',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'home-footer',
        type: 'footer-block',
        title: 'Home Footer Section',
        content: {},
        isActive: true,
        order: 4,
        settings: {},
        pageId: 'home',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'home-simple-text',
        type: 'simple-text-block',
        title: 'Welcome Message',
        content: 'Welcome to Aarit Special School & Therapy Centre. We are dedicated to providing exceptional care and education for children with special needs. Our team of professionals works tirelessly to ensure every child reaches their full potential in a nurturing and supportive environment.',
        isActive: true,
        order: 5,
        settings: {},
        pageId: 'home',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  'about': {
    id: 'about',
    name: 'About',
    slug: 'about',
    isActive: true,
    settings: {
      seoTitle: 'About Aarit Special School - Our Journey of Care and Excellence',
      seoDescription: 'Founded with a vision to provide exceptional care and education for children with special needs',
      metaKeywords: 'about, special school, Aarit, special needs, education',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'about-header',
        type: 'page-header',
        title: 'About Page Header',
        content: {
          title: 'About Aarit Special School',
          subtitle: 'Our Journey of Care and Excellence',
          description: 'Founded with a vision to provide exceptional care and education for children with special needs, Aarit Special School has been a beacon of hope and progress for families across the region.',
          buttonText: 'Learn More',
          buttonLink: '#about-content',
          compact: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'about',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'about-content',
        type: 'about-block',
        title: 'About Content Section',
        content: {},
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'about',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'about-footer',
        type: 'footer-block',
        title: 'About Footer Section',
        content: {},
        isActive: true,
        order: 3,
        settings: {},
        pageId: 'about',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  'contact': {
    id: 'contact',
    name: 'Contact',
    slug: 'contact',
    isActive: true,
    settings: {
      seoTitle: 'Contact Aarit Special School - Get in Touch',
      seoDescription: 'Contact us for enrollment, information, or to learn more about our special education programs',
      metaKeywords: 'contact, enrollment, special school, Aarit, inquiry',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'contact-header',
        type: 'page-header',
        title: 'Contact Page Header',
        content: {
          title: 'Contact Us',
          subtitle: 'Get in Touch with Aarit Special School',
          description: 'We\'re here to help and answer any questions you might have. We look forward to hearing from you.',
          buttonText: 'Send Message',
          buttonLink: '#contact-form',
          compact: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'contact',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'contact-form',
        type: 'contact-block',
        title: 'Contact Form Section',
        content: {},
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'contact',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'contact-footer',
        type: 'footer-block',
        title: 'Contact Footer Section',
        content: {},
        isActive: true,
        order: 3,
        settings: {},
        pageId: 'contact',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  'services': {
    id: 'services',
    name: 'Services',
    slug: 'services',
    isActive: true,
    settings: {
      seoTitle: 'Services - Aarit Special School & Therapy Centre',
      seoDescription: 'Comprehensive special education and therapeutic services for children with special needs',
      metaKeywords: 'services, special education, therapy, special needs, Aarit',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'services-header',
        type: 'page-header',
        title: 'Services Page Header',
        content: {
          title: 'Our Services',
          subtitle: 'Comprehensive Care and Education',
          description: 'We offer a wide range of specialized services designed to meet the unique needs of each child.',
          buttonText: 'Learn More',
          buttonLink: '#services-content',
          compact: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'services',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'services-content',
        type: 'services-block',
        title: 'Services Content Section',
        content: {},
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'services',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'services-footer',
        type: 'footer-block',
        title: 'Services Footer Section',
        content: {},
        isActive: true,
        order: 3,
        settings: {},
        pageId: 'services',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  'news': {
    id: 'news',
    name: 'News',
    slug: 'news',
    isActive: true,
    settings: {
      seoTitle: 'News & Updates - Aarit Special School',
      seoDescription: 'Stay updated with the latest news, events, and achievements at Aarit Special School',
      metaKeywords: 'news, updates, events, achievements, Aarit School',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'news-header',
        type: 'page-header',
        title: 'News Page Header',
        content: {
          title: 'News & Updates',
          subtitle: 'Stay Connected with Aarit Special School',
          description: 'Keep up with the latest news, events, achievements, and important updates from our school community.',
          buttonText: 'View All News',
          buttonLink: '#news-content',
          compact: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'news',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'news-content',
        type: 'news-block',
        title: 'News Content Section',
        content: {
          title: 'Latest News & Updates',
          subtitle: 'Stay informed about our school\'s latest happenings and achievements',
          articles: [
            {
              id: '1',
              title: 'Aarit Special School Celebrates 15 Years of Excellence',
              excerpt: 'This year marks a significant milestone as we celebrate 15 years of dedicated service to children with special needs. Our journey has been filled with countless success stories and transformative experiences.',
              content: 'Full article content would go here...',
              author: {
                name: 'Dr. Priya Sharma',
                role: 'Principal'
              },
              category: 'achievement',
              tags: ['anniversary', 'celebration', 'milestone'],
              publishDate: '2024-01-20',
              readTime: 5,
              views: 342,
              likes: 28,
              isFeatured: true,
              isBreaking: false
            },
            {
              id: '2',
              title: 'New Sensory Integration Program Launches This Month',
              excerpt: 'We are excited to announce the launch of our enhanced sensory integration program, designed to provide better support for children with sensory processing challenges.',
              content: 'Full article content would go here...',
              author: {
                name: 'Ms. Anjali Patel',
                role: 'Head of Therapy'
              },
              category: 'update',
              tags: ['sensory integration', 'therapy', 'new program'],
              publishDate: '2024-01-18',
              readTime: 4,
              views: 189,
              likes: 15,
              isFeatured: false,
              isBreaking: true
            },
            {
              id: '3',
              title: 'Student Arjun Wins Regional Art Competition',
              excerpt: 'We are proud to announce that our student Arjun has won first place in the Regional Special Needs Art Competition, showcasing his incredible talent and creativity.',
              content: 'Full article content would go here...',
              author: {
                name: 'Mr. Rajesh Kumar',
                role: 'Art Teacher'
              },
              category: 'achievement',
              tags: ['art', 'competition', 'student success'],
              publishDate: '2024-01-15',
              readTime: 3,
              views: 156,
              likes: 22,
              isFeatured: false,
              isBreaking: false
            }
          ],
          showSearch: true,
          showFilters: true,
          maxDisplay: 6,
          layout: 'grid'
        },
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'news',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'news-footer',
        type: 'footer-block',
        title: 'News Footer Section',
        content: {},
        isActive: true,
        order: 3,
        settings: {},
        pageId: 'news',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  'testimonials': {
    id: 'testimonials',
    name: 'Testimonials',
    slug: 'testimonials',
    isActive: true,
    settings: {
      seoTitle: 'Testimonials - Aarit Special School',
      seoDescription: 'Read what parents and students say about their experience at Aarit Special School',
      metaKeywords: 'testimonials, reviews, feedback, Aarit School, special education',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'testimonials-header',
        type: 'page-header',
        title: 'Testimonials Page Header',
        content: {
          title: 'What Parents & Students Say',
          subtitle: 'Real Stories from Our Community',
          description: 'Discover the impact Aarit Special School has had on families through the words of those who know us best.',
          buttonText: 'Read More Stories',
          buttonLink: '#testimonials-content',
          compact: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'testimonials',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'testimonials-content',
        type: 'testimonials-block',
        title: 'Testimonials Content Section',
        content: {},
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'testimonials',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'testimonials-footer',
        type: 'footer-block',
        title: 'Testimonials Footer Section',
        content: {},
        isActive: true,
        order: 3,
        settings: {},
        pageId: 'testimonials',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  'gallery': {
    id: 'gallery',
    name: 'Gallery',
    slug: 'gallery',
    isActive: true,
    settings: {
      seoTitle: 'Gallery - Aarit Special School',
      seoDescription: 'View photos and videos from our school activities and events',
      metaKeywords: 'gallery, photos, videos, school activities, Aarit School',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'gallery-header',
        type: 'page-header',
        title: 'Gallery Page Header',
        content: {
          title: 'Our Gallery',
          subtitle: 'Capturing Special Moments',
          description: 'Browse through our collection of photos and videos showcasing the vibrant life at Aarit Special School.',
          buttonText: 'View Gallery',
          buttonLink: '#gallery-content',
          compact: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'gallery',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'gallery-content',
        type: 'gallery-block',
        title: 'Gallery Content Section',
        content: {},
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'gallery',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  'events': {
    id: 'events',
    name: 'Events',
    slug: 'events',
    isActive: true,
    settings: {
      seoTitle: 'Events - Aarit Special School',
      seoDescription: 'Stay updated with upcoming events and activities at Aarit Special School',
      metaKeywords: 'events, activities, school calendar, Aarit School',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'events-header',
        type: 'page-header',
        title: 'Events Page Header',
        content: {
          title: 'Upcoming Events',
          subtitle: 'Join Our Community Activities',
          description: 'Discover exciting events, workshops, and activities happening at Aarit Special School.',
          buttonText: 'View Calendar',
          buttonLink: '#events-content',
          compact: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'events',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'events-content',
        type: 'news-block',
        title: 'Events Content Section',
        content: {},
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'events',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  'team': {
    id: 'team',
    name: 'Our Team',
    slug: 'team',
    isActive: true,
    settings: {
      seoTitle: 'Our Team - Aarit Special School',
      seoDescription: 'Meet our dedicated team of educators, therapists, and support staff',
      metaKeywords: 'team, staff, educators, therapists, Aarit School',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'team-header',
        type: 'page-header',
        title: 'Team Page Header',
        content: {
          title: 'Our Dedicated Team',
          subtitle: 'Professionals Committed to Excellence',
          description: 'Meet the passionate educators, therapists, and support staff who make Aarit Special School a place of growth and learning.',
          buttonText: 'Meet Our Team',
          buttonLink: '#team-content',
          compact: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'team',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'team-content',
        type: 'team-block',
        title: 'Team Content Section',
        content: {},
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'team',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  'therapy': {
    id: 'therapy',
    name: 'Therapy Services',
    slug: 'therapy',
    isActive: true,
    settings: {
      seoTitle: 'Therapy Services - Aarit Special School',
      seoDescription: 'Specialized therapeutic services for children with special needs',
      metaKeywords: 'therapy, special needs, occupational therapy, speech therapy, Aarit School',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'therapy-header',
        type: 'page-header',
        title: 'Therapy Services Header',
        content: {
          title: 'Therapy Services',
          subtitle: 'Specialized Care for Every Child',
          description: 'Our comprehensive therapy services are designed to support the unique needs of each child.',
          buttonText: 'Learn More',
          buttonLink: '#therapy-content',
          compact: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'therapy',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'therapy-content',
        type: 'therapy-block',
        title: 'Therapy Services Content Section',
        content: {
          title: 'Our Therapy Services',
          subtitle: 'Specialized Care for Every Child',
          description: 'Our comprehensive therapy services are designed to support the unique needs of each child, promoting development, independence, and overall well-being.',
          services: [
            {
              id: '1',
              name: 'Occupational Therapy',
              description: 'Helps children develop fine motor skills, daily living activities, and sensory processing abilities.',
              benefits: ['Improved motor coordination', 'Enhanced daily living skills', 'Better sensory integration'],
              duration: '45-60 minutes',
              frequency: '2-3 times per week',
              icon: 'ExperimentOutlined',
              color: '#3b82f6',
              isPopular: true
            },
            {
              id: '2',
              name: 'Speech Therapy',
              description: 'Addresses communication challenges, language development, and speech articulation issues.',
              benefits: ['Enhanced communication skills', 'Improved language development', 'Better articulation'],
              duration: '30-45 minutes',
              frequency: '2-4 times per week',
              icon: 'MessageOutlined',
              color: '#10b981'
            },
            {
              id: '3',
              name: 'Physical Therapy',
              description: 'Focuses on gross motor skills, balance, coordination, and physical strength development.',
              benefits: ['Improved mobility', 'Enhanced balance', 'Increased strength'],
              duration: '45-60 minutes',
              frequency: '2-3 times per week',
              icon: 'HeartOutlined',
              color: '#ef4444'
            },
            {
              id: '4',
              name: 'Sensory Integration Therapy',
              description: 'Helps children process and respond to sensory information more effectively.',
              benefits: ['Better sensory processing', 'Reduced sensory overload', 'Improved focus'],
              duration: '30-45 minutes',
              frequency: '2-3 times per week',
              icon: 'EyeOutlined',
              color: '#f59e0b'
            },
            {
              id: '5',
              name: 'Behavioral Therapy',
              description: 'Addresses challenging behaviors and promotes positive social interactions.',
              benefits: ['Improved behavior', 'Better social skills', 'Enhanced emotional regulation'],
              duration: '45-60 minutes',
              frequency: '1-2 times per week',
              icon: 'TeamOutlined',
              color: '#8b5cf6'
            },
            {
              id: '6',
              name: 'Play Therapy',
              description: 'Uses play as a medium to help children express emotions and develop coping skills.',
              benefits: ['Emotional expression', 'Coping skills development', 'Enhanced creativity'],
              duration: '30-45 minutes',
              frequency: '1-2 times per week',
              icon: 'StarOutlined',
              color: '#ec4899'
            }
          ],
          features: [
            'Individualized treatment plans for each child',
            'Experienced and certified therapists',
            'Family-centered approach with parent involvement',
            'Regular progress monitoring and assessments',
            'Integration with educational programs',
            'Modern therapy equipment and facilities'
          ],
          testimonials: [
            {
              id: '1',
              name: 'Priya Sharma',
              role: 'Parent of Arjun (8 years)',
              content: 'The occupational therapy sessions have made a remarkable difference in Arjun\'s daily activities. He\'s now much more independent!',
              rating: 5
            },
            {
              id: '2',
              name: 'Rajesh Kumar',
              role: 'Parent of Meera (6 years)',
              content: 'Speech therapy has helped Meera communicate so much better. Her confidence has grown tremendously.',
              rating: 5
            },
            {
              id: '3',
              name: 'Anjali Patel',
              role: 'Parent of Rohan (10 years)',
              content: 'The sensory integration therapy has been life-changing for Rohan. He\'s much more comfortable in different environments now.',
              rating: 5
            }
          ]
        },
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'therapy',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  },
  'achievements': {
    id: 'achievements',
    name: 'Achievements',
    slug: 'achievements',
    isActive: true,
    settings: {
      seoTitle: 'Achievements - Aarit Special School',
      seoDescription: 'Celebrating the successes and achievements of our students and school',
      metaKeywords: 'achievements, success, awards, recognition, Aarit School',
      layout: 'default',
      theme: 'light'
    },
    blocks: [
      {
        id: 'achievements-header',
        type: 'page-header',
        title: 'Achievements Header',
        content: {
          title: 'Our Achievements',
          subtitle: 'Celebrating Success Together',
          description: 'Discover the remarkable achievements and milestones of our students and school community.',
          buttonText: 'View Achievements',
          buttonLink: '#achievements-content',
          compact: true
        },
        isActive: true,
        order: 1,
        settings: {},
        pageId: 'achievements',
        createdAt: new Date(),
        updatedAt: new Date()
      },
      {
        id: 'achievements-content',
        type: 'achievements-block',
        title: 'Achievements Content Section',
        content: {
          title: 'Celebrating Our Success Stories',
          subtitle: 'Milestones That Define Our Journey',
          achievements: [
            {
              id: '1',
              title: '15 Years of Excellence',
              description: 'Celebrating 15 years of dedicated service to children with special needs, impacting over 500 families.',
              year: '2024',
              category: 'institutional',
              icon: '🏆'
            },
            {
              id: '2',
              title: 'Regional Recognition Award',
              description: 'Received the prestigious Regional Excellence Award for Special Education from the State Education Board.',
              year: '2023',
              category: 'recognition',
              icon: '🏅'
            },
            {
              id: '3',
              title: 'Student Success Stories',
              description: 'Over 80% of our students have shown significant improvement in their learning and development milestones.',
              year: '2023',
              category: 'student',
              icon: '⭐'
            },
            {
              id: '4',
              title: 'Innovation in Therapy',
              description: 'Introduced cutting-edge sensory integration techniques that have become a model for other institutions.',
              year: '2022',
              category: 'innovation',
              icon: '💡'
            },
            {
              id: '5',
              title: 'Community Outreach',
              description: 'Successfully conducted 25+ awareness programs reaching over 1000 families in the community.',
              year: '2022',
              category: 'community',
              icon: '🤝'
            },
            {
              id: '6',
              title: 'Professional Development',
              description: 'Our team of 15 therapists and educators received advanced certifications in specialized education.',
              year: '2021',
              category: 'team',
              icon: '📚'
            }
          ],
          stats: [
            {
              label: 'Years of Service',
              value: '15+',
              description: 'Dedicated to excellence'
            },
            {
              label: 'Students Helped',
              value: '500+',
              description: 'Lives transformed'
            },
            {
              label: 'Success Rate',
              value: '85%',
              description: 'Positive outcomes'
            },
            {
              label: 'Team Members',
              value: '25+',
              description: 'Expert professionals'
            }
          ]
        },
        isActive: true,
        order: 2,
        settings: {},
        pageId: 'achievements',
        createdAt: new Date(),
        updatedAt: new Date()
      }
    ],
    createdAt: new Date(),
    updatedAt: new Date()
  }
};

export const getLocalPageData = (slug: string): Page | null => {
  return localPageData[slug] || null;
};

export const getAllLocalPageSlugs = (): string[] => {
  return Object.keys(localPageData);
};
